import injectSheet from 'react-jss';
import theme, { expandAbsolutely } from '../../styles/theme';
import round from '../../helpers/round';

const maxWidth = theme.breakpoints.width('xxl');
const relativeBottomPadding = theme.breakpoints.upscaled(60);
const getNavigationItemSpacing = (dir, prop) => ({
  flex: 1,
  textAlign: dir,
  [prop]: '8%',
  [theme.breakpoints.up('md')]: {
    [prop]: '8%',
  },
  [theme.breakpoints.up('lg')]: {
    [prop]: '20%',
  },
  [theme.breakpoints.up('xxl')]: {
    [prop]: '30%',
  },
});
export default injectSheet({
  wrapper: {
    maxWidth,
    margin: [0, 'auto'],
    transition: 'color 0.3s ease-out',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: ({ isCarousel, hidePipsOnMobile }) => (
        isCarousel && !hidePipsOnMobile ? 60 : 0
      ),
    },
    '&.noPadding': {
      marginBottom: '0 !important',
    },
  },
  // note: using different classes for the different permutations of isDark here, rather than
  // makeResponsiveSettings() (or a media query with a dynamic function rule), because for some
  // reason I haven't figured out, JSS fails to update the dynamic style at runtime with the error:
  //   `Warning: Rule is not linked. Missing sheet option "link: true".`
  // This problem might go away with the next release of JSS (or at least, I'll be able to rewrite
  // the dynamic rules as `className: () => { rule, @mq }`) because cssinjs/jss#878 was recently
  // merged.
  darkWrapper: {
    color: theme.colors.black,
  },
  lightWrapper: {
    color: theme.colors.white,
  },
  desktopDarkWrapper: {
    [theme.breakpoints.up('md')]: {
      color: theme.colors.black,
    },
  },
  desktopLightWrapper: {
    [theme.breakpoints.up('md')]: {
      color: theme.colors.white,
    },
  },
  edgeToEdgeWrapper: {
    maxWidth: 'none',
  },
  slidesWrapper: {
    position: 'relative',
    paddingTop: ({ aspects }) => `${round(100 / aspects.mobile)}%`,
    [theme.breakpoints.up('md')]: {
      paddingTop: ({ aspects }) => `${round(100 / aspects.desktop)}%`,
    },
  },
  slides: {
    ...expandAbsolutely,
  },
  slide: {}, // required for Swiper’s slideClassName prop
  pips: {
    position: 'absolute',
    left: 20,
    right: 20,
    bottom: -45,
    color: theme.colors.black,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      color: 'inherit',
      left: 'auto',
      right: 40,
      bottom: theme.spacing.vertical.xs,
    },
    [theme.breakpoints.up('lg')]: {
      right: 60,
      bottom: 45,
    },
    '&.hidePipsOnMobile': {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '&.header_1': {
      [theme.breakpoints.up('md')]: {
        bottom: 32,
      },
      [theme.breakpoints.up('lg')]: {
        bottom: 32,
      },
      [theme.breakpoints.up('xxl')]: {
        bottom: 32,
      },
    },
  },
  pipsMirror: {
    // a placeholder to balance the space taken up on the RHS by the pips
    // (only required on desktop)
    width: ({ slideCount }) => slideCount * 24,
    height: 20,
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  bottom: {
    position: 'absolute',
    left: 20,
    right: 20,
    bottom: 25,
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      left: 40,
      right: 40,
      bottom: 40,
    },
    [theme.breakpoints.up('lg')]: {
      left: 60,
      right: 60,
      bottom: 40,
    },
    '&.header_1': {
      [theme.breakpoints.up('lg')]: {
        bottom: 60,
      },
    },
  },
  edgeToEdgeBottom: {
    [theme.breakpoints.up('xxl')]: {
      left: relativeBottomPadding,
      right: relativeBottomPadding,
      bottom: relativeBottomPadding,
    },
    '& $navItems': {
      [theme.breakpoints.up('xxl')]: {
        margin: [0, relativeBottomPadding],
      },
    },
    '& $pipsMirror': {
      [theme.breakpoints.up('xxl')]: {
        width: ({ slideCount }) => theme.breakpoints.upscaled(slideCount * 24),
      },
    },
  },
  navItems: {
    position: 'absolute',
    left: '50%',
    bottom: 25,
    transform: 'translateX(-50%)',
    width: '70%',
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('md')]: {
      bottom: 40,
      transform: 'translateX(-50%)',
      width: '42%',
    },
    [theme.breakpoints.up('lg')]: {
      bottom: 40,
      width: '47%',
    },
    [theme.breakpoints.up('xl')]: {
      width: '52%',
    },
    '&.header_1': {
      [theme.breakpoints.up('lg')]: {
        bottom: 32,
      },
    },
    '& > span:first-child': {
      ...getNavigationItemSpacing('right', 'marginRight'),
    },
    '& > span:last-child': {
      ...getNavigationItemSpacing('left', 'marginLeft'),
    },
  },
});
